import React from "react";
import View from '../../pages/setNewPassword';


class SetNewPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
        };
    }

    resetPassword = (password) => {
        let token = new URLSearchParams(this.props.history.location.search).get('token');
        this.props.resetPassword(token, password)
            .then((res) => {
                if(res) {
                    this.props.history.push("/login");
                }

            })
    };

    render() {

        return (
            <View
                resetPassword={this.resetPassword}

            />
        );
    }
}

export default SetNewPassword;